import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DoctorProfileTypeModalPage } from './doctor-profile-type-modal.page';

const routes: Routes = [
  {
    path: '',
    component: DoctorProfileTypeModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DoctorProfileTypeModalPageRoutingModule {}
